/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getRebateProgramCode,
  setSuspendedDtData,
  dispatchCheckLog,
  dispatchCheckLogData,
  setErrorMessages,
} from '../Store/actions';
import DisplayErrorMessages from '../../../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../../../SharedModules/Errors/SuccessMessage';
import ConfirmationPopup from './confirmationPopup';
import cancelIcon from '../../../../../../assets/images/Icon-cancel.png';
import { PaperComponent } from '../../../../../../SharedModules/utilities/utilities';

function RemoveSuspendedDt() {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  const rebateProgramCode = useSelector(
    (state) =>
      state.sharedState.RemoveSuspendedDtReducer?.rebateProgramCode?.data
  );

  const suspendedDateData = useSelector(
    (state) => state.sharedState.RemoveSuspendedDtReducer?.suspendedDtData
  );

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const checkLogData = useSelector(
    (state) => state.sharedState.RemoveSuspendedDtReducer?.checkLogData
  );

  const errorMessages = useSelector(
    (state) => state.sharedState.RemoveSuspendedDtReducer?.errorMessages
  );

  const getRebateProgramCodeValue = (values) => {
    dispatch(getRebateProgramCode(values));
  };

  const handleErrorMessages = (messages) => {
    dispatch(setErrorMessages(messages));
  };

  const isNumber = (evt) => {
    evt = evt || window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode !== 8 && charCode !== 0 && charCode < 48) || charCode > 57) {
      evt.preventDefault();
      handleErrorMessages(['You must enter a valid Check Log Number']);
      return false;
    }
    handleErrorMessages([]);
    return true;
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    setSuccessMessages([]);
    dispatch(
      setSuspendedDtData({
        ...suspendedDateData,
        planType: !suspendedDateData?.planType
          ? UserDefaultValues?.planTypeCd
          : suspendedDateData?.planType,
        rebateProgramCode: !suspendedDateData?.rebateProgramCode
          ? UserDefaultValues?.rebateProgramCd
          : suspendedDateData?.rebateProgramCode,
        checkLogNo: suspendedDateData?.checkLogNo,
      })
    );
  }, []);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/removeSuspendedDt') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  useEffect(() => {
    if (suspendedDateData?.planType) {
      getRebateProgramCodeValue(suspendedDateData?.planType);
    }
  }, [suspendedDateData?.planType]);

  useEffect(() => {
    if (rebateProgramCode && rebateProgramCode.length > 0) {
      dispatch(
        setSuspendedDtData({
          ...suspendedDateData,
        })
      );
    }
  }, [rebateProgramCode]);

  const handlereqRecordMailingData = (e) => {
    setSuccessMessages([]);
    handleErrorMessages([]);
    dispatch(
      setSuspendedDtData({
        ...suspendedDateData,
        [e.target.name]: e.target.value,
        ...('planType' in suspendedDateData &&
          e.target.name === 'planType' && { rebateProgramCode: '-1' }),
      })
    );
  };

  useEffect(() => {
    setSuccessMessages([]);
    if (checkLogData) {
      if (checkLogData.checkLogNum) {
        if (checkLogData.suspendedDt) {
          setShowConfirmationPopup(true);
        } else {
          setShowConfirmationPopup(false);
          setSuccessMessages([CONSTANTS.SUSPENDED_DT_REM_SUCCESS]);
        }
      } else if (typeof checkLogData === 'string') {
        handleErrorMessages([checkLogData]);
      } else if (typeof checkLogData !== 'string') {
        handleErrorMessages([CONSTANTS.ERR_PROCESSING_REQ]);
      }
    }
  }, [checkLogData]);

  const processSuspendedDate = () => {
    const checkPayeeCdData = rebateProgramCode.filter((item) => {
      return item.rebateProgramCd === suspendedDateData?.rebateProgramCode;
    });
    const removeSuspendedDtPayload = {
      checkLogNum: suspendedDateData?.checkLogNo,
      checkPayeeCd: checkPayeeCdData[0]?.checkPayeeCd,
      deleteFlag: true,
      rebateProgramCd: suspendedDateData?.rebateProgramCode,
    };
    dispatch(dispatchCheckLog(removeSuspendedDtPayload));
    // setSpinnerLoader(true);
  };

  const handleConfirmationPopup = () => {
    handleErrorMessages([]);
    setSuccessMessages([]);
    if(!suspendedDateData?.planType
      && !suspendedDateData?.rebateProgramCode && 
      !suspendedDateData?.checkLogNo){
      handleErrorMessages([CONSTANTS.PLAN_TYPE_REQUIRED,CONSTANTS.REBATE_PGM_REQ,CONSTANTS.CHECK_LOG_NO_REQ]);
    }
   else if(
   suspendedDateData?.rebateProgramCode ==='-1' &&
   !suspendedDateData?.checkLogNo){
      handleErrorMessages([CONSTANTS.REBATE_PGM_REQ,CONSTANTS.CHECK_LOG_NO_REQ]);
    }
   else if(!suspendedDateData?.planType
      &&  !suspendedDateData?.checkLogNo){
      handleErrorMessages([CONSTANTS.PLAN_TYPE_REQUIRED,CONSTANTS.CHECK_LOG_NO_REQ]);
    }
   else if(!suspendedDateData?.planType
      && !suspendedDateData?.rebateProgramCode ){
      handleErrorMessages([CONSTANTS.PLAN_TYPE_REQUIRED,CONSTANTS.REBATE_PGM_REQ]);
    } 
    else if (!suspendedDateData?.checkLogNo) {
      handleErrorMessages([CONSTANTS.CHECK_LOG_NO_REQ]);
    } else if(suspendedDateData?.rebateProgramCode==="-1"){
      handleErrorMessages([CONSTANTS.REBATE_PGM_REQ]);
    }
     else if(suspendedDateData?.planType === '' ||
      suspendedDateData?.planType === null || !suspendedDateData?.planType){
      handleErrorMessages([CONSTANTS.PLAN_TYPE_REQUIRED]);
    }
    else {
      const checkPayeeCdData = rebateProgramCode.filter((item) => {
        return item.rebateProgramCd === suspendedDateData?.rebateProgramCode;
      });
      const checkLogPayload = {
        checkLogNum: suspendedDateData?.checkLogNo,
        checkPayeeCd: checkPayeeCdData[0]?.checkPayeeCd,
        deleteFlag: false,
        rebateProgramCd: suspendedDateData?.rebateProgramCode,
      };
      dispatch(dispatchCheckLogData(''));
      dispatch(dispatchCheckLog(checkLogPayload));
    }
  };

  return (
    <div className="tabs-container">
      <div className="tBillPanel custom-check">
        <Dialog
          open={showConfirmationPopup}
          onClose={() => setShowConfirmationPopup(false)}
          data-testid="close-copy-contact-popup"
          maxWidth="md"
          className="inbuilt-dialog dialogPanel custom-check dialog-900"
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle
            className="copy-contact-title"
            style={{ cursor: 'move' }}
            id="draggable-dialog-title"
          >
            <div className="float-left dialog-heading-txt mt-1">
              Remove Check Log Suspended Date
            </div>

            <div
              className="close-popup-icon float-right"
              role="button"
              onClick={() => setShowConfirmationPopup(false)}
            >
              <img alt="" src={cancelIcon} />
            </div>
            <div className="clearfix" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <ConfirmationPopup />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper mb-2">
              <div className="float-right hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="reset-contact-detail"
                  onClick={processSuspendedDate}
                >
                  <SVGComponent iconName="Icon_awesome-check-circle" />
                  Ok
                </Button>
                <Button
                  data-testid="copy-contact-close"
                  className="btn btn-cancel btn-primary"
                  onClick={() => setShowConfirmationPopup(false)}
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
              <div className="clearfix" />
            </div>
          </DialogActions>
        </Dialog>
        <div className="panel tBillPanel-space devider-line pb-0">
          <CustomSeparator
            parent1="System"
            parent2="Technical Window"
            parent3="Online Fixes"
            parent4="Remove Suspended Date"
          />
          <DisplayErrorMessages errorMessages={errorMessages} />
          <DisplaySuccessMessages successMessages={successMessages} />
          <div className="panel mb-3">
            <div className="row">
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend
                    className="same-font-family"
                    id="demo-row-radio-buttons-group-label"
                  >
                    Plan Type
                  </legend>
                  <div className="form-wrapper p-0 mt-2">
                    <div className="mui-custom-form input-md field-xl">
                      <div className="sub-radio no-margin">
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="planType"
                            onChange={handlereqRecordMailingData}
                            value={suspendedDateData?.planType || ''}
                            required
                          >
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="FD"
                              control={<Radio />}
                              label="Medicaid"
                              data-test="Medicaid"
                            />
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="COMM"
                              control={<Radio />}
                              label="Commercial"
                              data-test="Commercial"
                            />
                            <FormControlLabel
                              style={{ marginRight: '10px' }}
                              value="ST"
                              control={<Radio />}
                              label="State"
                              data-test="State"
                            />
                            <FormControlLabel
                              value="SUPP"
                              control={<Radio />}
                              label="Supplemental"
                              data-test="Supplemental"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">Rebate Program</legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        label="Rebate Program"
                        fullWidth
                        select
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ id: 'rebateProgramCode' }}
                        required
                        onChange={handlereqRecordMailingData}
                        id="rebateProgramCode"
                        name="rebateProgramCode"
                        value={suspendedDateData?.rebateProgramCode || '-1'}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {rebateProgramCode &&
                        rebateProgramCode.length &&
                        rebateProgramCode.length > 0
                          ? rebateProgramCode.map((item) => {
                              return (
                                <MenuItem
                                  key={item.rebateProgramCd}
                                  value={item.rebateProgramCd}
                                >
                                  {item.rebateProgramCd} {'|'} {item.shortDescr}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-sm-4">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">Check Log Number</legend>
                  <div className="form-wrapper p-0">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        label="Check Log Number"
                        fullWidth
                        required
                        placeholder=""
                        value={suspendedDateData?.checkLogNo}
                        id="checkLogNo"
                        name="checkLogNo"
                        // inputProps={{ maxlength: 11 }}
                        onChange={handlereqRecordMailingData}
                        onKeyPress={isNumber}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 38, id: 'checkLogNo' }}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div className="row float-right">
              <div className="col-sm-12">
                <div className="btn-wrapper">
                  <div className="hide-on-print">
                    <Button
                      className="btn-success same-font-family frr-btn-width-17 mt-4"
                      onClick={() => handleConfirmationPopup()}
                    >
                      <SVGComponent iconName="Create-new-icon" /> Process
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withRouter(RemoveSuspendedDt);
